"use client";
import { usePathname } from "next/navigation";
import { useCallback } from "react";
import useDebounceSearch from "@/hooks/useDebounceSearch";
import { FAQResponseType } from "@/types/post";
import { trackEvent } from "@/utils/analytics";
import FAQInput from "./FAQInput";
import FAQList from "./FAQList";

interface FAQSectionProps {
  faqs: FAQResponseType[];
}

function FAQSection({ faqs }: FAQSectionProps) {
  const path = usePathname();

  const { keyword, onChangeSearch } = useDebounceSearch();

  const filtered = faqs.filter((faq) => faq.title.includes(keyword) || faq.content.includes(keyword));

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeSearch(e);
      const query = e.target.value.trim();
      if (query) {
        trackEvent("service_search", path, { search_query: query });
      }
    },
    [onChangeSearch],
  );

  return (
    <section className="mt-20 w-full px-side py-32">
      <div className="mx-auto w-full max-w-[800px]">
        <h2 className="mb-12 text-center text-36 font-semibold">궁금한 점이 있으신가요?</h2>
        <FAQInput className="mb-10" onChange={handleSearch} />
        <FAQList faqs={filtered} />
      </div>
    </section>
  );
}

export default FAQSection;
